<template>
  <div class="business-rule-dialog text-left">
    <modal-title :title="title" @close="$emit('close')" />
    <div v-if="!showNewRuleForm">
      <p>Optionally choose a display rule to apply to this content:</p>
      <rule-selector
        v-model="businessRuleId"
        @new-rule="showNewRuleForm = true"
      ></rule-selector>
    </div>
    <div v-else>
      <h3>New Display Rule</h3>
      <rule-form
        @save="newRuleCreated"
        @cancel="showNewRuleForm = false"
      ></rule-form>
    </div>
    <form-buttons>
      <button
        v-if="!showNewRuleForm"
        type="button"
        class="btn btn-primary"
        @click="continueClicked"
      >
        Insert
      </button>
    </form-buttons>
  </div>
</template>
<script>
import ModalTitle from "@/components/common/modal/ModalTitle.vue";
import RuleSelector from "@/components/business-rules/RuleSelector.vue";
import RuleForm from "@/components/business-rules/RuleForm.vue";

const newRuleCreated = function(newRule) {
  this.businessRuleId = newRule.id;
  this.showNewRuleForm = false;
};

const continueClicked = function() {
  this.$emit("continue", this.businessRuleId);
};

export default {
  props: {
    title: {
      type: String,
      required: false,
      default: "Display Rule",
    },
  },
  components: { RuleSelector, RuleForm, ModalTitle },
  data: function() {
    return {
      showNewRuleForm: false,
      businessRuleId: "",
    };
  },
  emits: ["continue", "close"],
  methods: {
    newRuleCreated,
    continueClicked,
  },
};
</script>
